import { useTranslation } from "react-i18next";
import { Selector } from "../Selector";

const VarietySelector = ({ selectedItemId, selectHandler, interaction }) => {
  const { t } = useTranslation();
  const options = [
    { id: "outcome", label: t("dashboard.los") },
    { id: "standard", label: t("dashboard.standards") },
  ];
  return (
    <Selector
      id="type-select"
      size="small"
      label={t("dashboard.loVariety")}
      selectedItemId={selectedItemId}
      selectHandler={selectHandler}
      options={options}
      interaction={interaction}
    />
  );
};

export default VarietySelector;
